import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Tag, Ticket, ShoppingBag, Users, Star, RotateCcw, Mail, LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  ["Dashboard", "/admin", <LayoutDashboard size={14} key="d" />],
  ["Producten", "/admin/producten", <Package size={14} key="p" />],
  ["Merken & korting", "/admin/merken", <Tag size={14} key="m" />],
  ["Bestellingen", "/admin/bestellingen", <ShoppingBag size={14} key="b" />],
  ["Klanten", "/admin/klanten", <Users size={14} key="k" />],
  ["Reviews", "/admin/reviews", <Star size={14} key="r" />],
  ["Retouren", "/admin/retouren", <RotateCcw size={14} key="rt" />],
  ["Berichten", "/admin/berichten", <Mail size={14} key="br" />],
];

export const AdminLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-obsidian flex" data-testid="admin-layout">
      <aside className="hidden lg:flex flex-col w-64 border-r border-gold/10 bg-ink/60 fixed inset-y-0">
        <div className="p-8 border-b border-gold/10">
          <Logo compact />
          <p className="mt-3 font-mono text-[9px] tracking-[0.3em] uppercase text-gold/80">Beheerderspaneel</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {LINKS.map(([label, path, icon]) => (
            <NavLink
              key={path}
              to={path}
              data-testid={`admin-nav-${path.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 font-mono text-[11px] tracking-[0.2em] uppercase transition-colors ${
                  isActive ? "text-gold bg-gold/10 border border-gold/25" : "text-mist hover:text-cream"
                }`
              }
            >
              {icon} {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-gold/10">
          <p className="px-4 text-xs text-smoke truncate">{user?.email}</p>
          <button data-testid="admin-logout" onClick={async () => { await logout(); navigate("/"); }} className="mt-3 w-full flex items-center gap-3 px-4 py-3 font-mono text-[11px] tracking-[0.2em] uppercase text-mist hover:text-red-300 transition-colors">
            <LogOut size={14} /> Uitloggen
          </button>
        </div>
      </aside>
      <div className="flex-1 lg:ml-64">
        <div className="lg:hidden flex items-center justify-between px-6 h-16 border-b border-gold/10 bg-ink/60 sticky top-0 z-40">
          <Logo compact />
          <div className="flex gap-4 overflow-x-auto">
            {LINKS.slice(0, 5).map(([label, path]) => (
              <NavLink key={path} to={path} className="font-mono text-[9px] tracking-[0.15em] uppercase text-mist whitespace-nowrap">{label}</NavLink>
            ))}
          </div>
        </div>
        <main className="p-6 sm:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
